export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-sumi py-14 sm:py-20 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Card */}
        <div className="bg-sumi/80 rounded-lg p-7 sm:p-12 relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute -top-4 -left-4 w-16 sm:w-24 h-16 sm:h-24 bg-indigo rotate-12 rounded-sm"></div>
          <div className="absolute -bottom-4 -right-4 w-20 sm:w-32 h-20 sm:h-32 bg-indigo -rotate-12 rounded-sm"></div>

          <div className="relative grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
            {/* Left Block - Logo & Mission */}
            <div className="col-span-2 md:col-span-1 space-y-4 sm:space-y-6">
              <div className="flex items-center gap-3 mb-2 sm:mb-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/79998c31-8dcb-4257-9950-200bb8348595.png"
                  alt="Institute Logo"
                  className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                />
              </div>
              <h3 className="font-sans text-sm sm:text-base text-white leading-relaxed">
                Institute of Japanese Musical Art Expression
              </h3>
              <p className="font-sans text-xs text-white/80 leading-relaxed">
                Produced by Shogo Yoshii
              </p>
              <p className="font-sans text-xs sm:text-sm text-white/70 leading-loose">
                A research institute that analyzes and reconstructs the somatic knowledge of Japanese music based on insular sensibility.
              </p>
            </div>

            {/* Research */}
            <div>
              <h4 className="font-sans text-xs font-semibold text-white/90 mb-3 sm:mb-4 tracking-widest uppercase">
                Research
              </h4>
              <nav className="space-y-2 sm:space-y-3">
                <button
                  onClick={() => scrollToSection('philosophy')}
                  className="block font-sans text-xs sm:text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Philosophy
                </button>
                <button
                  onClick={() => scrollToSection('philosophy')}
                  className="block font-sans text-xs sm:text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Methodology
                </button>
              </nav>
            </div>

            {/* Solutions */}
            <div>
              <h4 className="font-sans text-xs font-semibold text-white/90 mb-3 sm:mb-4 tracking-widest uppercase">
                Solutions
              </h4>
              <nav className="space-y-2 sm:space-y-3">
                {['Ensemble I', 'Ensemble Ro', 'Ensemble Ha', 'Ensemble Ni'].map((label) => (
                  <button
                    key={label}
                    onClick={() => scrollToSection('ensemble')}
                    className="block font-sans text-xs sm:text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {label}
                  </button>
                ))}
              </nav>
            </div>

            {/* About + Follow */}
            <div>
              <h4 className="font-sans text-xs font-semibold text-white/90 mb-3 sm:mb-4 tracking-widest uppercase">
                About
              </h4>
              <nav className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                <button
                  onClick={() => scrollToSection('credentials')}
                  className="block font-sans text-xs sm:text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Credentials
                </button>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="block font-sans text-xs sm:text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact
                </button>
              </nav>

              <h4 className="font-sans text-xs font-semibold text-white/90 mb-3 sm:mb-4 tracking-widest uppercase">
                Follow
              </h4>
              <div className="flex flex-row sm:flex-col gap-3">
                {[
                  { href: '#', icon: 'ri-instagram-line', label: 'Instagram' },
                  { href: '#', icon: 'ri-youtube-line', label: 'YouTube' },
                  { href: '#', icon: 'ri-linkedin-line', label: 'LinkedIn' },
                ].map(({ href, icon, label }) => (
                  <a
                    key={label}
                    href={href}
                    className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center text-white/70 hover:text-indigo transition-colors cursor-pointer"
                    aria-label={label}
                  >
                    <i className={`${icon} text-lg sm:text-xl`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="mt-8 sm:mt-12 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4 text-white/50 text-xs font-sans">
          <p className="text-center md:text-left">© 2025 Institute of Japanese Musical Art Expression. All rights reserved.</p>
          <div className="flex gap-4 sm:gap-6">
            <a href="#" className="hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </a>
            <span>|</span>
            <a href="#" className="hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
